import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Apollo } from 'apollo-angular';
import { CookieService } from 'ngx-cookie-service';
import { FiltersM, typesApex } from '../../../components/models';
import { DataService } from '../../../services/data/data.service';
import { ExcelService } from '../../../services/excel/excel.service';
import { CuentaEntity, EvaluacionEntity, Detalle_Evaluacion_CuentaEntity } from '../../funciones/AlertaTemprana';
import { messages } from '../../funciones/mensajes';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { getCuenta, getEvaluaciones } from './../../../services/financiero/estados-resultados/querys';
import { companiesFinanciero } from '../../../shared/catalogos';
import { HttpHeaders } from '@angular/common/http';
import { calculos, periodos } from '../../funciones/funcionesGenerales';
import { activosPonderados, obtenerCodigoPropio } from '../idsTablas';
import { CoberturaService } from '../../../services/financiero/cobertura/cobertura.service';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-activos-ponderados',
  templateUrl: './activos-ponderados.component.html',
  styleUrl: './activos-ponderados.component.css'
})
export class ActivosPonderadosComponent {
  public Filters = FiltersM;
  @ViewChild('grafica') graficador: GraficadorComponent;
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private cuentaEntity = new CuentaEntity;
  private evaluacionEntity = new EvaluacionEntity;
  private detalleCuentasEvaluacion = new Detalle_Evaluacion_CuentaEntity;
  public modalOpen: boolean = false;
  public Periodos = [];
  public PeriodosOri = [];
  public subTitles = [];
  public cadenaEvaluacion = [];
  private maxPeriodos = 4;
  private periodosSeleccionados = 0;
  public dataOrdenado = []
  private dataAll = [];
  public tablasExpand = [false,false,false,false,false,false]
  public miles: string = ',';
  public decimal: string = '.';
  public tarjetas = [];
  public tituloGraf = '';
  public dataGraf;
  public dataEtiquetas = [];
  public etiquetas = false;
  public colorScheme = ['#004A97', '#68B4D6', '#82CC60', '#FFCB03', '#FC8A33', '#F74C58'];
  public typeGraph = typesApex;
  public tipo = this.typeGraph.BARHORIZONTAL;
  public openModal = false;
    //Variables de personalizacion
  public multiMoneda: boolean;
  public codigoPropio: boolean;
  
  constructor(
    public dataService: DataService,
    private service: CoberturaService,
    private apollo: Apollo,
    private translate: TranslateService,
    private cookieService: CookieService,
    private excelService: ExcelService,
  ) {
    this.cuentaEntity = new CuentaEntity;
    this.evaluacionEntity = new EvaluacionEntity;
    this.evaluacionEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.evaluacionEntity.Id_Institucion = Number(cookieService.get('idInstitucion'));
    this.cuentaEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.personalizacion();
    this.getEvaluacion();
  }
  private personalizacion(){
    const settings = companiesFinanciero.find(i => i.id == this.evaluacionEntity.Id_Institucion+'');
    this.multiMoneda = settings.multiMoneda;
    this.codigoPropio = settings.codigoPropio;
  }
  /* Consultas */
  private async getEvaluacion(){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getEvaluaciones,
          context: { headers: this.headers, },
          variables: { idPlantilla: this.cuentaEntity.Id_Plantilla }
        }).valueChanges.source
      );

      var aux = [];
      for(const per of data.evaluaciones){
        if(per.idInstitucion === this.evaluacionEntity.Id_Institucion){
          aux.push(per);
        }
      }
      this.ordenamientoDataEvaluacion(aux);
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private ordenamientoDataEvaluacion(datos){
    // this.tituloTabla = 'financiero.catalogoCuentas.tituloTabla1';
    const info = periodos.obtenerPeriodos(datos, this.maxPeriodos);
    this.Periodos = info.periodos;
    this.PeriodosOri = info.periodos;
    for(const an of this.Periodos){
      if(an.anio < 2023){
        an.utilizable = false;
      }
    }
    this.ultimasEvaluaciones();
  }
  private ultimasEvaluaciones(){
    this.cadenaEvaluacion = [];
    this.subTitles = [];
    this.periodosSeleccionados = 0;
    var i=0, cadena = '';
    for(const an of this.Periodos){
      if(an.utilizable){
        for(const mes of an.series){
          if(mes.check){
            this.periodosSeleccionados++;
            this.cadenaEvaluacion.push({
              evaluacion: mes.periodo,
              id: mes.id,
              porcentaje: '%',
            });
            if(i===0){
              this.subTitles.push(mes.periodo);
              cadena = ''+mes.id;
            }else{
              this.subTitles.push(' | ')
              this.subTitles.push(mes.periodo);
              cadena += ','+mes.id;
            }
            i++;
          }
        }
      }
    }
    this.getDatosAT();
  }
  private async getDatosAT(){
    try{
      const cuentasAT = activosPonderados.cuentasAT(this.cuentaEntity.Id_Plantilla);
      if(Object.keys(cuentasAT).length == 0){
        var nombre = companiesFinanciero.find(c => Number(c.id) === Number(this.cookieService.get('idInstitucion'))).name;
        messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
      }else{
        const evaluaciones = this.Periodos.flatMap(a => a.series).filter(p => p.check);
        var datos = [];
        await this.getCuentas(cuentasAT['cuentas'], datos);
        await this.agregarACuentasTotal(
          cuentasAT['cuentas'],
          evaluaciones,
          this.service.getDetalleCuenta.bind(this.service),
          'detalleEvaluacionCuenta',
          'idCuenta',
          datos
        );
        // await this.agregarACuentasTotal(
        //   cuentasAT['varTemp'],
        //   evaluaciones,
        //   this.service.getVarTemp.bind(this.service),
        //   'detalleEvaluacionVarTemp',
        //   'idVarTemp',
        //   datos
        // );

        // await this.agregarACuentasTotal(
        //   cuentasAT['var'],
        //   evaluaciones,
        //   this.service.getVariable.bind(this.service),
        //   'detalleEvaluacionVariable',
        //   'idVariable',
        //   datos
        // );  
        this.getDatosTabla(datos);
      }      
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }  
  private async getCuentas(cuentas, cuentasTotal){
    try{
      for(const i of cuentas){
        const { data }  = await firstValueFrom(
          this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
            query: getCuenta,
            context: { headers: this.headers, },
            variables: { cuentaId: i, idPlantilla: this.cuentaEntity.Id_Plantilla, params:{
              id: i,
              idPlantilla: this.cuentaEntity.Id_Plantilla
            }}
          }).valueChanges.source
        );
        cuentasTotal[data.cuenta.id] ??= [];
        cuentasTotal[data.cuenta.id].push({
          descripcion: data.cuenta.descripcion,
          id: data.cuenta.id,
          series: []
        });
      }
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }     
  private async agregarACuentasTotal<T>(cuentas: string[],periodos: any[],servicio: (idEval: number, id: string) => Promise<any>,
    detalleKey: string, idKey: string, cuentasTotal:any[]) {
    const promesas = periodos.flatMap(periodo =>
      cuentas.map(id =>
        servicio(periodo.id, id)
      )
    );
    const resultados = await Promise.all(promesas);
    resultados.forEach(r => {
      const detalle = r?.[detalleKey];
      if (!detalle) return;
      const idCuenta = detalle[idKey];
      cuentasTotal[idCuenta][0].series.push(detalle);
    });
  }
  private getDatosTabla(data){
    this.dataAll = data;
    const numSeries = Object.values(data)[0][0].series;
    var posSuma, posSumaT, posTab, posAux; 
    var dataTabla = [], aux = [], genAux = [];
    for(var i = 0; ;i++){
      const d = activosPonderados.tabla(this.cuentaEntity.Id_Plantilla, i);
      if(d === undefined){
        break;
      }else{
        if(d.codigo.includes('editable')){ //TODO agregamos los editables y esta pendiente como los vamos a consultar
          const elementAux = {
            id: '',
            codigo: '',
            descripcion:d.descripcion,
            series: Array.from({ length: numSeries.length },() => ({ valor: 0 })),
            edit: d.edit
          }
          aux.push(elementAux);
          genAux.push(elementAux);
        }else if(d.codigo === 'suma'){ //calculamos el subtotal,
          const arregloSumas = Array.from({ length: numSeries.length },() => ({ valor: 0 }));
          if(d?.formula){
            posSumaT = i;
            const formula = d.formula
            const c = formula.split(' ');
            dataTabla[0][0].series.forEach( (s, iS) =>{
              var signo = '';
              c.forEach( e => {
                if(!isNaN(Number(e))){
                  arregloSumas[iS].valor = calculos.operations(arregloSumas[iS].valor, signo||'+' ,genAux[Number(e)-1].series[iS].valor)                  
                }else{
                  signo=e;
                }
              });
            })
          }else{
            for(const n of aux){
              for(let pos = 0; pos < n.series.length; pos++){
                arregloSumas[pos].valor+=n.series[pos].valor;
              }
            }
          }
          const elementAux = {
            id: '',
            codigo: d.codigo,
            descripcion:d.descripcion,
            series: arregloSumas,
            edit: d.edit
          };  
          aux.push(elementAux);
          genAux.push(elementAux);
          dataTabla.push(aux);
          aux = [];
        }else if(d.codigo === 'sumas'){// caso especial suma de otras cuentas
          posSuma = i;
          posTab = dataTabla.length;
          posAux = aux.length;
          const arregloSumas = Array.from({ length: numSeries.length },() => ({ valor: 0 }));
          const elementAux = {
            id: '',
            codigo: '',
            descripcion:d.descripcion,
            series: arregloSumas,
            edit: d.edit
          };  
          aux.push(elementAux);
          genAux.push(elementAux);
        }else if(d.codigo.includes('total')){
          if(this.evaluacionEntity.Id_Plantilla === 13 && d.codigo === 'total'){//manejamos el caso especial de la suma 
            var s = activosPonderados.tabla(this.cuentaEntity.Id_Plantilla, posSuma);
            var form = s.formula;
            var cn = form.split(' ');
            const arreglo = Array.from({ length: numSeries.length },() => ({ valor: 0 }));
            dataTabla[0][0].series.forEach( (s, iS) =>{
              var signo = '';
              cn.forEach( e => {
                if(!isNaN(Number(e))){
                  arreglo[iS].valor = calculos.operations(arreglo[iS].valor, signo||'+' ,genAux[Number(e)-1].series[iS].valor);
                }else{
                  signo=e;
                }
              });
            })
            dataTabla[posTab][posAux].series = arreglo;
            genAux[posSuma-1].series = arreglo;
            //Actualizar el total de la tabla 5
            const st = activosPonderados.tabla(this.cuentaEntity.Id_Plantilla, 58);
            form = st.formula
            cn = form.split(' ');
            const arregloSumasT = Array.from({ length: numSeries.length },() => ({ valor: 0 }));
            dataTabla[0][0].series.forEach( (s, iS) =>{
              var signo = '';
              cn.forEach( e => {
                if(!isNaN(Number(e))){
                  arregloSumasT[iS].valor = calculos.operations(arregloSumasT[iS].valor, signo||'+' ,genAux[Number(e)-1].series[iS].valor)
                }else{
                  signo=e;
                }
              });
            });
            dataTabla[posTab][dataTabla[posTab].length-1].series = arregloSumasT;
            genAux[posSumaT-1].series = arregloSumasT;
          }
          const formula = d.formula
          const c2 = formula.split(' ');
          const arreglo = Array.from({ length: numSeries.length },() => ({ valor: 0 }));
          dataTabla[0][0].series.forEach( (s, iS) =>{
            var signo = '';
            c2.forEach( e => {
              if(!isNaN(Number(e))){
                arreglo[iS].valor = calculos.operations(arreglo[iS].valor, signo||'+' ,genAux[Number(e)-1].series[iS].valor)
              }else{
                signo=e;
              }
            });
          })
          const elementAux = {
            id: '',
            codigo: 'total',
            descripcion:d.descripcion,
            series: arreglo,
            edit: d.edit
          };  
          aux.push(elementAux);
          dataTabla.push(aux);
          genAux.push(elementAux);
          aux = [];
        }else if(d.codigo === 'titulo'){
          const elementAux = {
            id: '',
            codigo: d.codigo,
            descripcion:d.descripcion,
            series: Array.from({ length: numSeries.length },() => ({ valor: 0 })),
            edit: d.edit
          };  
          aux.push(elementAux);
          dataTabla.push(aux);
          aux = [];
        }else if (d.codigo === 'sub'){
          var s = activosPonderados.tabla(this.cuentaEntity.Id_Plantilla, i);
          var elementAux = {};
          const arreglo = Array.from({ length: numSeries.length },() => ({ valor: 0 }));
          if(s?.formula){
            var form = s.formula;
            var cn = form.split(' ');
            dataTabla[0][0].series.forEach( (s, iS) =>{
              var signo = '';
              cn.forEach( e => {
                if(!isNaN(Number(e))){                  
                  const operando = !e.includes('.') ? genAux[Number(e)-1].series[iS].valor : Number(e);
                  arreglo[iS].valor = calculos.operations(arreglo[iS].valor, signo||'+' , operando)
                }else{
                  signo=e;
                }
              });
            });
            elementAux = {
            id: '',
            codigo: 'total',
            descripcion:d.descripcion,
            series: arreglo,
            edit: d.edit,
            porcentaje: d?.porcentaje
          };
          }else if(s?.cuenta){
            elementAux = {
              id: '',
              codigo: 'total',
              cuenta: obtenerCodigoPropio.idsCodigoPropio(this.evaluacionEntity.Id_Plantilla, d.cuenta).codigo,
              descripcion:d.descripcion,
              series: data[d.cuenta][0].series,
              edit: d.edit
            };
          }
          if(d?.tarjeta){
            this.tarjetas.push({
              titulo: d.descripcion,
              valor: arreglo[numSeries.length-1].valor,
            })
          }
          aux.push(elementAux);
          genAux.push(elementAux);
          dataTabla.push(aux);
          aux = [];
        }else if(d.codigo === 'subcapital'){
          var sumaVI = new Array(numSeries.length).fill(0), 
              operando1 = Array.from({ length: numSeries.length },() => ({ valor: 0 }));
          const arreglo = Array.from({ length: numSeries.length },() => ({ valor: 0 }));
          for(let k=0; k < numSeries.length; k++){
            sumaVI[k] = data['P302101'][0].series[k].valor + data['P302102'][0].series[k].valor + data['P302105'][0].series[k].valor +
                    data['P302107'][0].series[k].valor + data['P302108'][0].series[k].valor;
            operando1[k] = data['P302109'][0].series[k].valor < 0 ? data['P302109'][0].series[k].valor : data['P302109'][0].series[k].valor/2;
            arreglo[k].valor = sumaVI[k] + operando1[k];
          }
          const elemntAux = {
            id: '',
            codigo: 'total',
            descripcion:d.descripcion,
            series: arreglo,
            edit: d.edit
          };
          aux.push(elemntAux);
          genAux.push(elemntAux);
          dataTabla.push(aux);
          aux = [];
        }else{
          var config = obtenerCodigoPropio.idsCodigoPropio(this.evaluacionEntity.Id_Plantilla, d.codigo);
          var desc = d?.descripcion ?? data[d.codigo][0].descripcion;
          const elemntAux = {
            id: d.codigo,
            codigo: config?.codigo,
            descripcion: desc,
            series: data[d.codigo][0].series,
            edit: d.edit
          };
          aux.push(elemntAux);
          genAux.push(elemntAux);
        }
      }
    }
    this.dataOrdenado = dataTabla;
    this.generarGrafica(this.dataOrdenado[1][this.dataOrdenado[1].length-1])
  }
  public generarGrafica(elem){
    this.tituloGraf = elem.descripcion;
    const data = elem.series;
    this.dataEtiquetas = [], this.dataGraf = [];
    var aux = [];
    for(let i = 0; i < this.cadenaEvaluacion.length; i++){
      this.dataEtiquetas.push(this.cadenaEvaluacion[i].evaluacion);
      aux.push(data[i].valor);
    }
    this.dataGraf = [{
      name: '',
      data: aux,
    }]
  }
  public cambioPeriodo(per){
    if( per.check || (!per.check && this.periodosSeleccionadosAct() < this.maxPeriodos ) ){
      per.check = !per.check;
      this.cadenaEvaluacion = [];
      this.subTitles = [];
      this.periodosSeleccionados = 0;
      var i=0, cadena = '';
      for(const an of this.Periodos){
        for(const mes of an.series){
          if(mes.check){
            this.periodosSeleccionados++;
            this.cadenaEvaluacion.push({
              evaluacion: mes.periodo,
              id: mes.id,
              porcentaje: '%',
            });
            if(i===0){
              this.subTitles.push(mes.periodo);
              cadena = ''+mes.id;
            }else{
              this.subTitles.push(' | ')
              this.subTitles.push(mes.periodo);
              cadena += ','+mes.id;
            }
            i++;
          }
        }
      }
      this.detalleCuentasEvaluacion.ArregloID_evaluacion = cadena;
      this.getDatosAT();
    }else{
      document.getElementById("check_"+per.mes+""+per.anio)['checked'] = false;
      messages.infoMessageGraph('No se pueden seleccionar mas de '+this.maxPeriodos+' periodos')
    }
  }
    /* formateo de datos */
  public escrituraPer(Periodo) {
    if (Periodo.split(' ').length === 2) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    } else if (Periodo.split(' ').length === 5) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1] + ' ' + datos[2] + ' ' + this.translate.instant('filtros.' + datos[3]) + ' ' + datos[4];
    }
    return Periodo;
  }
  private periodosSeleccionadosAct(){
    var sel = 0;
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.check){
          sel++;
        }
      }
    }
    return sel;
  }
  public mostrarIcon(numTab, pos){
    if(numTab!==9 && numTab!==7 && pos === this.dataOrdenado[numTab].length-1){
      return true
    }
    return false;
  }
  public async ingresarDato(elem, ind){
    var inputValue = elem.series[ind].valor;
    var guardo = false;
    let texto = elem.descripcion;

    const formatter = new Intl.NumberFormat('es-MX');
    const result = await Swal.fire({
      title: 'Ingresa el valor',
      text: texto,
      input: 'text',
      inputValue: formatter.format(inputValue),
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },

      didOpen: () => {
        const input = Swal.getInput() as HTMLInputElement;

        input.addEventListener('input', () => {
          // Quitar todo excepto números
          const rawValue = input.value.replace(/\D/g, '');

          // Formatear con separadores
          input.value = rawValue
            ? formatter.format(Number(rawValue))
            : '';
        });
      },

      preConfirm: (value) => {
        // Regresar número limpio sin comas
        guardo = true;
        return Number(value.replace(/,/g, ''));
      }
    });


    if(guardo){
      //TODO aqui se va a actualizar el dato en la tabla y posteriormente se va a actualizar en bd 
      elem.series[ind].valor = result.value;      
      messages.succesMessageGraph(this.translate.instant('swal.infoGuardado'))
    }else{
      messages.errorMessageGraph(this.translate.instant('swal.swalNoGuardo'));
    }      
  }
  public quitarFiltros(){
    this.Periodos = this.PeriodosOri;
    this.tablasExpand = [false,false,false,false,false,false]
    this.getDatosAT();
    this.etiquetas = false;
    this.tipo = this.typeGraph.BARHORIZONTAL;
  }
  public exportExcel(){
    let headers = [this.translate.instant('financiero.activosPonderados.tit1'),this.translate.instant('financiero.activosPonderados.tit2')];
    for(const p of this.subTitles){
      headers.push(p);
    }
    var aux = [], datos = [];
    for(const d of this.dataOrdenado){
      if(d.length === 1){
        if(d[0].codigo === 'total'){
          aux.push('-');
          aux.push(d[0].descripcion);
          for(const s of d[0].series){
            aux.push(s.valor);
          }
          datos.push(aux);
          aux = [];
        }else{
          datos.push(['-',d[0].descripcion,...Array(this.subTitles.length).fill('')]);
        }
      }else{
        for(const t of d){
          aux.push(!isNaN(Number(t.codigo)) ? t.codigo : t.codigo === 'suma' ? '-' : '');
          aux.push((t.descripcion) );
          for(const s of t.series){
            aux.push(s.valor);
          }
          datos.push(aux);
          aux = [];
        }
      }
    }
    let titulo = `${this.translate.instant('financiero.activosPonderados.tituloTabla')} | `;
    let nombreArch = `${this.translate.instant('financiero.activosPonderados.tituloTabla')}`;
    for(const p of this.subTitles){
      titulo += ` ${p}`
    }
    this.excelService.generateActivosPonderados(titulo, headers, datos, nombreArch);
  }
  public exportGraf(){
    if (this.graficador) {
      const tit = `${this.translate.instant('financiero.activosPonderados.evolucion')}  ${this.tituloGraf} • ${this.subTitles[this.subTitles.length-1]}`;
      const titulos = {
        titulo: tit,
        subtitulo: '',
        nombreArch: `${this.tituloGraf}`
      };
      this.graficador.exportImg(1, titulos);
    }
  }
}
